import { commonService } from '.';

const getListMyManagers = (body) => {
    return commonService.post('ListMyManager', body);
};

export const listMyManagerService = {
    getListMyManagers
};
